module.exports = __webpack_public_path__ + "static/media/pymes-bread.3784ba3b.svg";